/* kitsters-shipping-policy.js
   - Scroll reveal for .ksp__reveal elements
   - FAQ accordion (open/close, single-open mode)
   All animations gated by prefers-reduced-motion. */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll reveal ────────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.ksp__reveal');
    if (!els.length) return;

    if (reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* ── FAQ accordion ────────────────────────────────────────── */
  function initFaq() {
    var list = document.querySelector('[data-ksp-faq]');
    if (!list) return;

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.ksp__faq-btn');
      if (!btn) return;

      var item = btn.closest('[data-ksp-faq-item]');
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!item || !answer) return;

      var isOpen = item.classList.contains('is-open');

      /* Close any currently open item */
      list.querySelectorAll('[data-ksp-faq-item].is-open').forEach(function (openItem) {
        var openBtn = openItem.querySelector('.ksp__faq-btn');
        var openAns = openItem.querySelector('.ksp__faq-a');
        openItem.classList.remove('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        if (openAns) openAns.hidden = true;
      });

      /* Open the clicked item (unless it was already open) */
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
      }
    });
  }

  function init() {
    initReveal();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
